// Vendor libraries
import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i2 from "../../stress-test-edit-modal/stress-test-edit-modal.component";
import * as i3 from "../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
export class StressTestManageModalListItemComponent {
    constructor() {
        this.class = 'plate-container';
        this.editHandler = new EventEmitter();
        this.deleteHandler = new EventEmitter();
    }
    ngOnInit() {
        this.confirmDeleteText = `Are you sure you want to delete the ${this.stressTest.name} stress test?`;
    }
}
StressTestManageModalListItemComponent.ɵfac = function StressTestManageModalListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StressTestManageModalListItemComponent)(); };
StressTestManageModalListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StressTestManageModalListItemComponent, selectors: [["ycn-stress-test-manage-modal-list-item"]], hostVars: 2, hostBindings: function StressTestManageModalListItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassMap(ctx.class);
    } }, inputs: { stressTest: "stressTest" }, outputs: { editHandler: "editHandler", deleteHandler: "deleteHandler" }, standalone: false, decls: 13, vars: 7, consts: [["stressTestEditModal", ""], [1, "plate"], [1, "plate-header"], [1, "plate-title"], [1, "plate-controls"], ["ycnTooltip", "", "tooltipTitle", "Reorder", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "btn-reorder-up", "plate-control"], ["ycnIcon", "", 3, "name"], ["ycnTooltip", "", "tooltipTitle", "Edit", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", 3, "click"], ["ycnTooltip", "", "tooltipTitle", "Remove", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", 3, "click"], [3, "submitModalHandler", "stressTest", "saveAfterSubmit"]], template: function StressTestManageModalListItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(6, "svg", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵlistener("click", function StressTestManageModalListItemComponent_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r1); const stressTestEditModal_r2 = i0.ɵɵreference(12); return i0.ɵɵresetView(stressTestEditModal_r2.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(8, "svg", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵlistener("click", function StressTestManageModalListItemComponent_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.deleteHandler.emit()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(10, "svg", 6);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(11, "ycn-stress-test-edit-modal", 9, 0);
        i0.ɵɵlistener("submitModalHandler", function StressTestManageModalListItemComponent_Template_ycn_stress_test_edit_modal_submitModalHandler_11_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.editHandler.emit($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate2(" ", ctx.stressTest.name, " ", ctx.stressTest.description, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("name", "icon-reorder-up");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-edit");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-close");
        i0.ɵɵadvance();
        i0.ɵɵproperty("stressTest", ctx.stressTest)("saveAfterSubmit", true);
    } }, dependencies: [i1.IconDirective, i2.StressTestEditModalComponent, i3.TooltipDirective], encapsulation: 2 });
